import gql from "graphql-tag";

export const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      id
      email
      jwt
      refresh_jwt
      firstTime
      accountVerified
      language
    }
  }
`;

export const SIGNUP = gql`
  mutation signup(
    $email: String!
    $password: String!
    $role: String!
    $language: String!
  ) {
    signup(
      email: $email
      password: $password
      role: $role
      language: $language
    ) {
      id
      accountVerified
      jwt
      refresh_jwt
    }
  }
`;

export const REFRESH = gql`
  mutation updateAccess($refreshToken: String!, $accessToken: String!) {
    updateAccess(refreshToken: $refreshToken, accessToken: $accessToken)
  }
`;

export const RESEND_VERIFICATION = gql`
  mutation resendVerificationToken($email: String!) {
    resendVerificationToken(email: $email)
  }
`;

export const VERIFY_ACCOUNT = gql`
  mutation verifyAccount($email: String!, $verificationToken: String!) {
    verifyAccount(email: $email, verificationToken: $verificationToken) {
      id
      email
      jwt
      refresh_jwt
      firstTime
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $email: String!
    $verificationToken: String!
    $newPassword: String!
  ) {
    resetPassword(
      email: $email
      verificationToken: $verificationToken
      newPassword: $newPassword
    )
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
    ) {
      id
    }
  }
`;

export const DISABLE_INTRO = gql`
  mutation disableIntro {
    disableIntro
  }
`;

export const CURRENT_USER = gql`
  query currentUser {
    currentUser {
      id
      email
      language
    }
  }
`;

// PROFILE QUERIES

export const MY_PROFILE = gql`
  query getCurrentProfile {
    getCurrentProfile {
      id
      name
      last_name
      birth_date
      address
    }
  }
`;

export const CREATE_PROFILE = gql`
  mutation createProfile(
    $name: String!
    $last_name: String!
    $birth_date: String!
    $address: String!
  ) {
    createProfile(
      name: $name
      last_name: $last_name
      birth_date: $birth_date
      address: $address
    ) {
      id
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateProfile(
    $id: Int!
    $name: String
    $last_name: String
    $birth_date: String
    $address: String
  ) {
    updateProfile(
      id: $id
      name: $name
      last_name: $last_name
      birth_date: $birth_date
      address: $address
    ) {
      id
    }
  }
`;

export const CHANGE_LANGUAGE = gql`
  mutation changeLanguagePreference($locale: String!) {
    changeLanguagePreference(locale: $locale)
  }
`;
